<template>
  <v-menu v-model="shown"
          :top="top" :bottom="bottom"
          :left="left" :right="right"
          :offset-y="offsetY"
          :close-on-content-click="closeOnContentClick"
          max-height="100%"
  >
    <template #activator="{ on:onMenu, attrs }">
      <v-tooltip
        :disabled="tooltip.disabled"
        :top="tooltip.top" :bottom="tooltip.bottom"
        :left="tooltip.left" :right="tooltip.right">
        <template #activator="{ on:onTooltip }">
          <slot name="activator">
            <v-btn icon v-bind="attrs" v-on="{ ...onMenu, ...onTooltip}">
              <v-icon>mdi-checkbox-multiple-marked-outline</v-icon>
            </v-btn>
          </slot>
        </template>
        <template #default>
          <slot name="tooltip">Projects</slot>
        </template>
      </v-tooltip>
    </template>
    <template #default>
      <v-card>
        <v-card-text>
          <template v-for="project in project_items">
            <v-checkbox
              :key="project.id"
              :label="project.name" :value="project.id"
              v-model="selected"
              dense hide-details>
            </v-checkbox>
          </template>
        </v-card-text>
        <v-card-actions>

          <v-tooltip right>
            <template #activator="{ on }">
              <v-btn ref="btnClose" icon v-on="on"
                     @click="btnClose_click">
                <v-icon>mdi-close-outline</v-icon>
              </v-btn>
            </template>
            <template #default>
              <span>Close</span>
            </template>
          </v-tooltip>

          <v-spacer></v-spacer>

          <v-tooltip left>
            <template #activator="{ on }">
              <v-btn ref="btnSave" icon v-on="on"
                     :disabled="!is_changed" @click="btnSave_click">
                <v-icon>mdi-content-save-outline</v-icon>
              </v-btn>
            </template>
            <template #default>
              <span>Save</span>
            </template>
          </v-tooltip>
        </v-card-actions>
      </v-card>
    </template>

  </v-menu>
</template>

<script>

	import format from 'string-format'
	import {
		VMenu, VTooltip, VRow, VCol
	} from 'vuetify'
	import {mapActions, mapGetters} from "vuex"

	export default {
		name: "project-selector-menu",
		components: {
			VMenu, VTooltip, VRow, VCol
		},

		data: function () {
			return {
				shown: false,
				selected: [],
			}
		},

		props: {
			top: {type: Boolean, default: false,},
			bottom: {type: Boolean, default: false,},
			left: {type: Boolean, default: false,},
			right: {type: Boolean, default: false,},
			offsetY: {type: Boolean, default: false,},
			closeOnContentClick: {type: Boolean, default: false,},

			tooltip: {
				type: Object,
				default: function () {
					return {
						disabled: true,
						top: false,
						bottom: false,
						left: false,
						right: false
					}
				},
			},

			value: {type: Array, default: () => [],},
		},

		emitted: ['save',],

		watch: {
			value: function (new_value, old_value) {
				this.selected = this.value
			},

			shown: function (new_value, old_value) {
				console.debug(format(
					"ProjectSelectedMenu.watch.shown( {0} )", new_value))
			}
		},

		computed: {
			...mapGetters({
				project_list: 'lists/project_list',
			}),

			project_items: function () {
				return this.project_list.filter((p) => p.id > 0)
			},

			is_changed: function () {
				const eq = this.selected.length === this.value.length &&
					this.selected.every((p_id) => this.value.indexOf(p_id) !== -1) &&
					this.value.every((p_id) => this.selected.indexOf(p_id) !== -1)

				return !eq
			},
		},

		mounted: function () {
			this.selected = this.value
		},

		methods: {
			...mapActions({
				message_add: 'message/add',
			}),

			// -- Handle controls' events --

			btnClose_click: function (e) {
				this.selected = this.value
				this.shown = false
			},

			/**
			 * Здесь не знаем куда надо сохранить список отмеченных проектов,
			 * поэтому отправляем событие с этим списком
			 * @param e
			 */
			btnSave_click: function (e) {
				console.debug("ProjectSelectedMenu.btnSave_click()")

				this.$emit('save', this.selected)
				this.shown = false
			},
		},
	}


</script>

<style scoped>

</style>